// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export const GlobalParticipantType = {
    GLOBAL_PARTICIPANT_TYPE_UNDEFINED: 'GLOBAL_PARTICIPANT_TYPE_UNDEFINED',
    GLOBAL_PARTICIPANT_TYPE_CUSTOMER: 'GLOBAL_PARTICIPANT_TYPE_CUSTOMER',
    GLOBAL_PARTICIPANT_TYPE_IAM_USER: 'GLOBAL_PARTICIPANT_TYPE_IAM_USER',
    GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP: 'GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP',
    GLOBAL_PARTICIPANT_TYPE_PARTNER: 'GLOBAL_PARTICIPANT_TYPE_PARTNER',
    GLOBAL_PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT: 'GLOBAL_PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT',
    GLOBAL_PARTICIPANT_TYPE_DIGITAL_AGENT: 'GLOBAL_PARTICIPANT_TYPE_DIGITAL_AGENT',
    GLOBAL_PARTICIPANT_TYPE_VENDOR: 'GLOBAL_PARTICIPANT_TYPE_VENDOR',
    GLOBAL_PARTICIPANT_TYPE_OPENAI_BOT: 'GLOBAL_PARTICIPANT_TYPE_OPENAI_BOT',
    GLOBAL_PARTICIPANT_TYPE_ANONYMOUS: 'GLOBAL_PARTICIPANT_TYPE_ANONYMOUS',
    GLOBAL_PARTICIPANT_TYPE_GROUP: 'GLOBAL_PARTICIPANT_TYPE_GROUP',
    GLOBAL_PARTICIPANT_TYPE_AI_ASSISTANT: 'GLOBAL_PARTICIPANT_TYPE_AI_ASSISTANT',
    GLOBAL_PARTICIPANT_TYPE_PLATFORM_INTEGRATION_USER: 'GLOBAL_PARTICIPANT_TYPE_PLATFORM_INTEGRATION_USER',
};
export const GlobalParticipantTypeValue = {
    GLOBAL_PARTICIPANT_TYPE_UNDEFINED: 0,
    GLOBAL_PARTICIPANT_TYPE_CUSTOMER: 1,
    GLOBAL_PARTICIPANT_TYPE_IAM_USER: 2,
    GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP: 3,
    GLOBAL_PARTICIPANT_TYPE_PARTNER: 4,
    GLOBAL_PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT: 5,
    GLOBAL_PARTICIPANT_TYPE_DIGITAL_AGENT: 6,
    GLOBAL_PARTICIPANT_TYPE_VENDOR: 7,
    GLOBAL_PARTICIPANT_TYPE_OPENAI_BOT: 8,
    GLOBAL_PARTICIPANT_TYPE_ANONYMOUS: 9,
    GLOBAL_PARTICIPANT_TYPE_GROUP: 10,
    GLOBAL_PARTICIPANT_TYPE_AI_ASSISTANT: 11,
    GLOBAL_PARTICIPANT_TYPE_PLATFORM_INTEGRATION_USER: 12,
};
export const SortDirection = {
    SORT_DIRECTION_DESCENDING: 'SORT_DIRECTION_DESCENDING',
    SORT_DIRECTION_ASCENDING: 'SORT_DIRECTION_ASCENDING',
};
export const SortDirectionValue = {
    SORT_DIRECTION_DESCENDING: 0,
    SORT_DIRECTION_ASCENDING: 1,
};
export const ConversationChannel = {
    CONVERSATION_CHANNEL_UNDEFINED: 'CONVERSATION_CHANNEL_UNDEFINED',
    CONVERSATION_CHANNEL_INTERNAL: 'CONVERSATION_CHANNEL_INTERNAL',
    CONVERSATION_CHANNEL_SMS: 'CONVERSATION_CHANNEL_SMS',
    CONVERSATION_CHANNEL_FACEBOOK: 'CONVERSATION_CHANNEL_FACEBOOK',
    CONVERSATION_CHANNEL_GOOGLE_MESSAGES: 'CONVERSATION_CHANNEL_GOOGLE_MESSAGES',
    CONVERSATION_CHANNEL_OPENAI: 'CONVERSATION_CHANNEL_OPENAI',
    CONVERSATION_CHANNEL_EMAIL: 'CONVERSATION_CHANNEL_EMAIL',
    CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS: 'CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS',
    CONVERSATION_CHANNEL_WEB_CHAT: 'CONVERSATION_CHANNEL_WEB_CHAT',
    CONVERSATION_CHANNEL_INSTAGRAM: 'CONVERSATION_CHANNEL_INSTAGRAM',
    CONVERSATION_CHANNEL_WHATSAPP: 'CONVERSATION_CHANNEL_WHATSAPP',
    CONVERSATION_CHANNEL_AI_ASSISTANT: 'CONVERSATION_CHANNEL_AI_ASSISTANT',
    CONVERSATION_CHANNEL_GOOGLE_CHAT: 'CONVERSATION_CHANNEL_GOOGLE_CHAT',
    CONVERSATION_CHANNEL_PERSONAL_EMAIL: 'CONVERSATION_CHANNEL_PERSONAL_EMAIL',
    CONVERSATION_CHANNEL_SYSTEM: 'CONVERSATION_CHANNEL_SYSTEM',
};
export const ConversationChannelValue = {
    CONVERSATION_CHANNEL_UNDEFINED: 0,
    CONVERSATION_CHANNEL_INTERNAL: 1,
    CONVERSATION_CHANNEL_SMS: 2,
    CONVERSATION_CHANNEL_FACEBOOK: 3,
    CONVERSATION_CHANNEL_GOOGLE_MESSAGES: 4,
    CONVERSATION_CHANNEL_OPENAI: 5,
    CONVERSATION_CHANNEL_EMAIL: 6,
    CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS: 7,
    CONVERSATION_CHANNEL_WEB_CHAT: 8,
    CONVERSATION_CHANNEL_INSTAGRAM: 9,
    CONVERSATION_CHANNEL_WHATSAPP: 10,
    CONVERSATION_CHANNEL_AI_ASSISTANT: 11,
    CONVERSATION_CHANNEL_GOOGLE_CHAT: 12,
    CONVERSATION_CHANNEL_PERSONAL_EMAIL: 13,
    CONVERSATION_CHANNEL_SYSTEM: 14,
};
export const PlatformLocation = {
    PLATFORM_LOCATION_UNDEFINED: 'PLATFORM_LOCATION_UNDEFINED',
    PLATFORM_LOCATION_BUSINESS_APP: 'PLATFORM_LOCATION_BUSINESS_APP',
    PLATFORM_LOCATION_PARTNER_CENTER: 'PLATFORM_LOCATION_PARTNER_CENTER',
    PLATFORM_LOCATION_VENDOR_CENTER: 'PLATFORM_LOCATION_VENDOR_CENTER',
    PLATFORM_LOCATION_TASK_MANAGER: 'PLATFORM_LOCATION_TASK_MANAGER',
    PLATFORM_LOCATION_PROPOSAL_BUILDER: 'PLATFORM_LOCATION_PROPOSAL_BUILDER',
    PLATFORM_LOCATION_SALES_CENTER: 'PLATFORM_LOCATION_SALES_CENTER',
    PLATFORM_LOCATION_ADMIN_CENTER: 'PLATFORM_LOCATION_ADMIN_CENTER',
    PLATFORM_LOCATION_REPUTATION_MANAGEMENT: 'PLATFORM_LOCATION_REPUTATION_MANAGEMENT',
    PLATFORM_LOCATION_CAMPAIGNS: 'PLATFORM_LOCATION_CAMPAIGNS',
    PLATFORM_LOCATION_SMS: 'PLATFORM_LOCATION_SMS',
    PLATFORM_LOCATION_CRM: 'PLATFORM_LOCATION_CRM',
    PLATFORM_LOCATION_VOICE: 'PLATFORM_LOCATION_VOICE',
    PLATFORM_LOCATION_AUTOMATA: 'PLATFORM_LOCATION_AUTOMATA',
    PLATFORM_LOCATION_WHATSAPP_BUSINESS_APP: 'PLATFORM_LOCATION_WHATSAPP_BUSINESS_APP',
};
export const PlatformLocationValue = {
    PLATFORM_LOCATION_UNDEFINED: 0,
    PLATFORM_LOCATION_BUSINESS_APP: 1,
    PLATFORM_LOCATION_PARTNER_CENTER: 2,
    PLATFORM_LOCATION_VENDOR_CENTER: 3,
    PLATFORM_LOCATION_TASK_MANAGER: 4,
    PLATFORM_LOCATION_PROPOSAL_BUILDER: 5,
    PLATFORM_LOCATION_SALES_CENTER: 6,
    PLATFORM_LOCATION_ADMIN_CENTER: 7,
    PLATFORM_LOCATION_REPUTATION_MANAGEMENT: 8,
    PLATFORM_LOCATION_CAMPAIGNS: 9,
    PLATFORM_LOCATION_SMS: 10,
    PLATFORM_LOCATION_CRM: 11,
    PLATFORM_LOCATION_VOICE: 12,
    PLATFORM_LOCATION_AUTOMATA: 13,
    PLATFORM_LOCATION_WHATSAPP_BUSINESS_APP: 14,
};
export const AssigneeSource = {
    ASSIGNEE_SOURCE_UNKNOWN: 'ASSIGNEE_SOURCE_UNKNOWN',
    ASSIGNEE_SOURCE_MANUAL: 'ASSIGNEE_SOURCE_MANUAL',
    ASSIGNEE_SOURCE_CRM_CONTACT_OWNER: 'ASSIGNEE_SOURCE_CRM_CONTACT_OWNER',
};
export const AssigneeSourceValue = {
    ASSIGNEE_SOURCE_UNKNOWN: 0,
    ASSIGNEE_SOURCE_MANUAL: 1,
    ASSIGNEE_SOURCE_CRM_CONTACT_OWNER: 2,
};
export const AIResponseMode = {
    AI_RESPONSE_MODE_UNSET: 'AI_RESPONSE_MODE_UNSET',
    AI_RESPONSE_MODE_OFF: 'AI_RESPONSE_MODE_OFF',
    AI_RESPONSE_MODE_AUTO_SEND: 'AI_RESPONSE_MODE_AUTO_SEND',
    AI_RESPONSE_MODE_AUTO_DRAFT: 'AI_RESPONSE_MODE_AUTO_DRAFT',
    AI_RESPONSE_MODE_INHERIT_SETTINGS: 'AI_RESPONSE_MODE_INHERIT_SETTINGS',
};
export const AIResponseModeValue = {
    AI_RESPONSE_MODE_UNSET: 0,
    AI_RESPONSE_MODE_OFF: 1,
    AI_RESPONSE_MODE_AUTO_SEND: 2,
    AI_RESPONSE_MODE_AUTO_DRAFT: 3,
    AI_RESPONSE_MODE_INHERIT_SETTINGS: 4,
};
export const UIQuestionFormQuestionQuestionType = {
    UNDEFINED: 'UNDEFINED',
    TEXT: 'TEXT',
    CHOICE: 'CHOICE',
    CONFIRM: 'CONFIRM',
};
export const UIQuestionFormQuestionQuestionTypeValue = {
    UNDEFINED: 0,
    TEXT: 1,
    CHOICE: 2,
    CONFIRM: 3,
};
export const MessageStatus = {
    MESSAGE_STATUS_NOT_READ: 'MESSAGE_STATUS_NOT_READ',
    MESSAGE_STATUS_READ: 'MESSAGE_STATUS_READ',
    MESSAGE_STATUS_SENT: 'MESSAGE_STATUS_SENT',
    MESSAGE_STATUS_DELIVERED: 'MESSAGE_STATUS_DELIVERED',
    MESSAGE_STATUS_FAILED: 'MESSAGE_STATUS_FAILED',
    MESSAGE_STATUS_UNDELIVERED: 'MESSAGE_STATUS_UNDELIVERED',
    MESSAGE_STATUS_SENDING: 'MESSAGE_STATUS_SENDING',
    MESSAGE_STATUS_PRE_SEND_PROCESSING: 'MESSAGE_STATUS_PRE_SEND_PROCESSING',
};
export const MessageStatusValue = {
    MESSAGE_STATUS_NOT_READ: 0,
    MESSAGE_STATUS_READ: 1,
    MESSAGE_STATUS_SENT: 2,
    MESSAGE_STATUS_DELIVERED: 3,
    MESSAGE_STATUS_FAILED: 4,
    MESSAGE_STATUS_UNDELIVERED: 5,
    MESSAGE_STATUS_SENDING: 6,
    MESSAGE_STATUS_PRE_SEND_PROCESSING: 7,
};
export const MessageType = {
    MESSAGE_TYPE_MESSAGE: 'MESSAGE_TYPE_MESSAGE',
    MESSAGE_TYPE_MEDIA: 'MESSAGE_TYPE_MEDIA',
    MESSAGE_TYPE_SYSTEM: 'MESSAGE_TYPE_SYSTEM',
    MESSAGE_TYPE_FORM_SUBMISSION: 'MESSAGE_TYPE_FORM_SUBMISSION',
    MESSAGE_TYPE_BOOKING_AVAILABILITY: 'MESSAGE_TYPE_BOOKING_AVAILABILITY',
    MESSAGE_TYPE_TEMPLATE: 'MESSAGE_TYPE_TEMPLATE',
};
export const MessageTypeValue = {
    MESSAGE_TYPE_MESSAGE: 0,
    MESSAGE_TYPE_MEDIA: 1,
    MESSAGE_TYPE_SYSTEM: 2,
    MESSAGE_TYPE_FORM_SUBMISSION: 3,
    MESSAGE_TYPE_BOOKING_AVAILABILITY: 4,
    MESSAGE_TYPE_TEMPLATE: 5,
};
export const UIComponentType = {
    UI_COMPONENT_TYPE_UNDEFINED: 'UI_COMPONENT_TYPE_UNDEFINED',
    UI_COMPONENT_TYPE_BUTTON: 'UI_COMPONENT_TYPE_BUTTON',
    UI_COMPONENT_TYPE_CHECKBOX_GROUP: 'UI_COMPONENT_TYPE_CHECKBOX_GROUP',
    UI_COMPONENT_TYPE_MARKDOWN_PLAN: 'UI_COMPONENT_TYPE_MARKDOWN_PLAN',
    UI_COMPONENT_TYPE_QUESTION_FORM: 'UI_COMPONENT_TYPE_QUESTION_FORM',
    UI_COMPONENT_TYPE_CHART: 'UI_COMPONENT_TYPE_CHART',
};
export const UIComponentTypeValue = {
    UI_COMPONENT_TYPE_UNDEFINED: 0,
    UI_COMPONENT_TYPE_BUTTON: 1,
    UI_COMPONENT_TYPE_CHECKBOX_GROUP: 2,
    UI_COMPONENT_TYPE_MARKDOWN_PLAN: 3,
    UI_COMPONENT_TYPE_QUESTION_FORM: 4,
    UI_COMPONENT_TYPE_CHART: 5,
};
export const AIStatus = {
    AI_INVALID: 'AI_INVALID',
    AI_RECEIVED: 'AI_RECEIVED',
    AI_THINKING: 'AI_THINKING',
    AI_THOUGHT: 'AI_THOUGHT',
    AI_CANCELLED: 'AI_CANCELLED',
    AI_ERROR: 'AI_ERROR',
};
export const AIStatusValue = {
    AI_INVALID: 0,
    AI_RECEIVED: 1,
    AI_THINKING: 2,
    AI_THOUGHT: 3,
    AI_CANCELLED: 4,
    AI_ERROR: 5,
};
export const ParticipantType = {
    PARTICIPANT_TYPE_UNDEFINED: 'PARTICIPANT_TYPE_UNDEFINED',
    PARTICIPANT_TYPE_CUSTOMER: 'PARTICIPANT_TYPE_CUSTOMER',
    PARTICIPANT_TYPE_IAM_USER: 'PARTICIPANT_TYPE_IAM_USER',
    PARTICIPANT_TYPE_ACCOUNT_GROUP: 'PARTICIPANT_TYPE_ACCOUNT_GROUP',
    PARTICIPANT_TYPE_PARTNER: 'PARTICIPANT_TYPE_PARTNER',
    PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT: 'PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT',
    PARTICIPANT_TYPE_DIGITAL_AGENT: 'PARTICIPANT_TYPE_DIGITAL_AGENT',
    PARTICIPANT_TYPE_VENDOR: 'PARTICIPANT_TYPE_VENDOR',
    PARTICIPANT_TYPE_OPENAI_BOT: 'PARTICIPANT_TYPE_OPENAI_BOT',
    PARTICIPANT_TYPE_ANONYMOUS: 'PARTICIPANT_TYPE_ANONYMOUS',
    PARTICIPANT_TYPE_GROUP: 'PARTICIPANT_TYPE_GROUP',
    PARTICIPANT_TYPE_AI_ASSISTANT: 'PARTICIPANT_TYPE_AI_ASSISTANT',
    PARTICIPANT_TYPE_PLATFORM_INTEGRATION_USER: 'PARTICIPANT_TYPE_PLATFORM_INTEGRATION_USER',
};
export const ParticipantTypeValue = {
    PARTICIPANT_TYPE_UNDEFINED: 0,
    PARTICIPANT_TYPE_CUSTOMER: 1,
    PARTICIPANT_TYPE_IAM_USER: 2,
    PARTICIPANT_TYPE_ACCOUNT_GROUP: 3,
    PARTICIPANT_TYPE_PARTNER: 4,
    PARTICIPANT_TYPE_IAM_TEMPORARY_SUBJECT: 5,
    PARTICIPANT_TYPE_DIGITAL_AGENT: 6,
    PARTICIPANT_TYPE_VENDOR: 7,
    PARTICIPANT_TYPE_OPENAI_BOT: 8,
    PARTICIPANT_TYPE_ANONYMOUS: 9,
    PARTICIPANT_TYPE_GROUP: 10,
    PARTICIPANT_TYPE_AI_ASSISTANT: 11,
    PARTICIPANT_TYPE_PLATFORM_INTEGRATION_USER: 12,
};
export const ViewType = {
    VIEW_TYPE_UNDEFINED: 'VIEW_TYPE_UNDEFINED',
    VIEW_TYPE_FOLLOWING: 'VIEW_TYPE_FOLLOWING',
};
export const ViewTypeValue = {
    VIEW_TYPE_UNDEFINED: 0,
    VIEW_TYPE_FOLLOWING: 1,
};
export const WidgetPosition = {
    WIDGET_POSITION_UNSPECIFIED: 'WIDGET_POSITION_UNSPECIFIED',
    WIDGET_POSITION_RIGHT: 'WIDGET_POSITION_RIGHT',
    WIDGET_POSITION_LEFT: 'WIDGET_POSITION_LEFT',
};
export const WidgetPositionValue = {
    WIDGET_POSITION_UNSPECIFIED: 0,
    WIDGET_POSITION_RIGHT: 1,
    WIDGET_POSITION_LEFT: 2,
};
export const WidgetAssistantKind = {
    WIDGET_ASSISTANT_KIND_INVALID: 'WIDGET_ASSISTANT_KIND_INVALID',
    WIDGET_ASSISTANT_KIND_CHAT_RECEPTIONIST: 'WIDGET_ASSISTANT_KIND_CHAT_RECEPTIONIST',
    WIDGET_ASSISTANT_KIND_CUSTOM: 'WIDGET_ASSISTANT_KIND_CUSTOM',
};
export const WidgetAssistantKindValue = {
    WIDGET_ASSISTANT_KIND_INVALID: 0,
    WIDGET_ASSISTANT_KIND_CHAT_RECEPTIONIST: 1,
    WIDGET_ASSISTANT_KIND_CUSTOM: 2,
};
export const EvaluationSentiment = {
    EVALUATION_SENTIMENT_UNDEFINED: 'EVALUATION_SENTIMENT_UNDEFINED',
    EVALUATION_SENTIMENT_POSITIVE: 'EVALUATION_SENTIMENT_POSITIVE',
    EVALUATION_SENTIMENT_NEGATIVE: 'EVALUATION_SENTIMENT_NEGATIVE',
};
export const EvaluationSentimentValue = {
    EVALUATION_SENTIMENT_UNDEFINED: 0,
    EVALUATION_SENTIMENT_POSITIVE: 1,
    EVALUATION_SENTIMENT_NEGATIVE: 2,
};
export const DraftDisposition = {
    DRAFT_DISPOSITION_UNSPECIFIED: 'DRAFT_DISPOSITION_UNSPECIFIED',
    DRAFT_DISPOSITION_SENT: 'DRAFT_DISPOSITION_SENT',
    DRAFT_DISPOSITION_DISMISSED: 'DRAFT_DISPOSITION_DISMISSED',
};
export const DraftDispositionValue = {
    DRAFT_DISPOSITION_UNSPECIFIED: 0,
    DRAFT_DISPOSITION_SENT: 1,
    DRAFT_DISPOSITION_DISMISSED: 2,
};
export const MessageDraftLifecycleState = {
    MESSAGE_DRAFT_LIFECYCLE_STATE_UNSPECIFIED: 'MESSAGE_DRAFT_LIFECYCLE_STATE_UNSPECIFIED',
    MESSAGE_DRAFT_LIFECYCLE_STATE_PENDING: 'MESSAGE_DRAFT_LIFECYCLE_STATE_PENDING',
    MESSAGE_DRAFT_LIFECYCLE_STATE_SENDING: 'MESSAGE_DRAFT_LIFECYCLE_STATE_SENDING',
    MESSAGE_DRAFT_LIFECYCLE_STATE_SENT: 'MESSAGE_DRAFT_LIFECYCLE_STATE_SENT',
    MESSAGE_DRAFT_LIFECYCLE_STATE_FAILED: 'MESSAGE_DRAFT_LIFECYCLE_STATE_FAILED',
    MESSAGE_DRAFT_LIFECYCLE_STATE_DISCARDED: 'MESSAGE_DRAFT_LIFECYCLE_STATE_DISCARDED',
    MESSAGE_DRAFT_LIFECYCLE_STATE_STALE: 'MESSAGE_DRAFT_LIFECYCLE_STATE_STALE',
};
export const MessageDraftLifecycleStateValue = {
    MESSAGE_DRAFT_LIFECYCLE_STATE_UNSPECIFIED: 0,
    MESSAGE_DRAFT_LIFECYCLE_STATE_PENDING: 1,
    MESSAGE_DRAFT_LIFECYCLE_STATE_SENDING: 2,
    MESSAGE_DRAFT_LIFECYCLE_STATE_SENT: 3,
    MESSAGE_DRAFT_LIFECYCLE_STATE_FAILED: 4,
    MESSAGE_DRAFT_LIFECYCLE_STATE_DISCARDED: 5,
    MESSAGE_DRAFT_LIFECYCLE_STATE_STALE: 6,
};
export const EventType = {
    EVENT_TYPE_UNDEFINED: 'EVENT_TYPE_UNDEFINED',
    EVENT_TYPE_SMS_UNSUBSCRIBED: 'EVENT_TYPE_SMS_UNSUBSCRIBED',
    EVENT_TYPE_CAMPAIGN: 'EVENT_TYPE_CAMPAIGN',
    EVENT_TYPE_REVIEW_REQUEST: 'EVENT_TYPE_REVIEW_REQUEST',
    EVENT_TYPE_FORM_SUBMISSION: 'EVENT_TYPE_FORM_SUBMISSION',
    EVENT_TYPE_PHONE_CALL: 'EVENT_TYPE_PHONE_CALL',
    EVENT_TYPE_SMS_SUBSCRIBED: 'EVENT_TYPE_SMS_SUBSCRIBED',
    EVENT_TYPE_DUPLICATE_CONVERSATION: 'EVENT_TYPE_DUPLICATE_CONVERSATION',
    EVENT_TYPE_NPS_FEEDBACK: 'EVENT_TYPE_NPS_FEEDBACK',
    EVENT_TYPE_REVIEW_RECEIVED: 'EVENT_TYPE_REVIEW_RECEIVED',
};
export const EventTypeValue = {
    EVENT_TYPE_UNDEFINED: 0,
    EVENT_TYPE_SMS_UNSUBSCRIBED: 1,
    EVENT_TYPE_CAMPAIGN: 3,
    EVENT_TYPE_REVIEW_REQUEST: 4,
    EVENT_TYPE_FORM_SUBMISSION: 5,
    EVENT_TYPE_PHONE_CALL: 6,
    EVENT_TYPE_SMS_SUBSCRIBED: 7,
    EVENT_TYPE_DUPLICATE_CONVERSATION: 8,
    EVENT_TYPE_NPS_FEEDBACK: 9,
    EVENT_TYPE_REVIEW_RECEIVED: 10,
};
export const ExportStatus = {
    EXPORT_STATUS_UNDEFINED: 'EXPORT_STATUS_UNDEFINED',
    EXPORT_STATUS_IN_PROGRESS: 'EXPORT_STATUS_IN_PROGRESS',
    EXPORT_STATUS_COMPLETED: 'EXPORT_STATUS_COMPLETED',
    EXPORT_STATUS_FAILED: 'EXPORT_STATUS_FAILED',
};
export const ExportStatusValue = {
    EXPORT_STATUS_UNDEFINED: 0,
    EXPORT_STATUS_IN_PROGRESS: 1,
    EXPORT_STATUS_COMPLETED: 2,
    EXPORT_STATUS_FAILED: 3,
};
export const AIMode = {
    AI_MODE_UNSET: 'AI_MODE_UNSET',
    AI_MODE_FAST: 'AI_MODE_FAST',
    AI_MODE_THINKING: 'AI_MODE_THINKING',
    AI_MODE_DEEP_RESEARCH: 'AI_MODE_DEEP_RESEARCH',
    AI_MODE_GENERATION: 'AI_MODE_GENERATION',
};
export const AIModeValue = {
    AI_MODE_UNSET: 0,
    AI_MODE_FAST: 1,
    AI_MODE_THINKING: 2,
    AI_MODE_DEEP_RESEARCH: 3,
    AI_MODE_GENERATION: 4,
};
export const Status = {
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    INFO: 'INFO',
    RESTRICTED: 'RESTRICTED',
};
export const StatusValue = {
    ERROR: 0,
    WARNING: 1,
    INFO: 2,
    RESTRICTED: 3,
};
export const EvaluateResponseType = {
    EVALUATION_RESPONSE_TYPE_UNSPECIFIED: 'EVALUATION_RESPONSE_TYPE_UNSPECIFIED',
    EVALUATION_RESPONSE_TYPE_EVENT: 'EVALUATION_RESPONSE_TYPE_EVENT',
    EVALUATION_RESPONSE_TYPE_MESSAGE: 'EVALUATION_RESPONSE_TYPE_MESSAGE',
};
export const EvaluateResponseTypeValue = {
    EVALUATION_RESPONSE_TYPE_UNSPECIFIED: 0,
    EVALUATION_RESPONSE_TYPE_EVENT: 1,
    EVALUATION_RESPONSE_TYPE_MESSAGE: 2,
};
export const CommunicationChannelType = {
    COMMUNICATION_CHANNEL_TYPE_UNDEFINED: 'COMMUNICATION_CHANNEL_TYPE_UNDEFINED',
    COMMUNICATION_CHANNEL_TYPE_SMS: 'COMMUNICATION_CHANNEL_TYPE_SMS',
    COMMUNICATION_CHANNEL_TYPE_VOICE: 'COMMUNICATION_CHANNEL_TYPE_VOICE',
};
export const CommunicationChannelTypeValue = {
    COMMUNICATION_CHANNEL_TYPE_UNDEFINED: 0,
    COMMUNICATION_CHANNEL_TYPE_SMS: 1,
    COMMUNICATION_CHANNEL_TYPE_VOICE: 2,
};
export const MetadataIdentifier = {
    METADATA_IDENTIFIER_UNDEFINED: 'METADATA_IDENTIFIER_UNDEFINED',
    METADATA_IDENTIFIER_RECIPIENT: 'METADATA_IDENTIFIER_RECIPIENT',
    METADATA_IDENTIFIER_SENDER: 'METADATA_IDENTIFIER_SENDER',
    METADATA_IDENTIFIER_CONVERSATION: 'METADATA_IDENTIFIER_CONVERSATION',
    METADATA_IDENTIFIER_WHATSAPP_TEMPLATE: 'METADATA_IDENTIFIER_WHATSAPP_TEMPLATE',
};
export const MetadataIdentifierValue = {
    METADATA_IDENTIFIER_UNDEFINED: 0,
    METADATA_IDENTIFIER_RECIPIENT: 1,
    METADATA_IDENTIFIER_SENDER: 2,
    METADATA_IDENTIFIER_CONVERSATION: 3,
    METADATA_IDENTIFIER_WHATSAPP_TEMPLATE: 4,
};
export const SetLastSeenRequestStatus = {
    SET_LAST_SEEN_REQUEST_STATUS_READ: 'SET_LAST_SEEN_REQUEST_STATUS_READ',
    SET_LAST_SEEN_REQUEST_STATUS_UNREAD: 'SET_LAST_SEEN_REQUEST_STATUS_UNREAD',
};
export const SetLastSeenRequestStatusValue = {
    SET_LAST_SEEN_REQUEST_STATUS_READ: 0,
    SET_LAST_SEEN_REQUEST_STATUS_UNREAD: 1,
};
export const GetWidgetConfigResponseGreetingMessageType = {
    GREETING_MESSAGE_UNDEFINED: 'GREETING_MESSAGE_UNDEFINED',
    GREETING_MESSAGE_NONE: 'GREETING_MESSAGE_NONE',
    GREETING_MESSAGE_CUSTOM: 'GREETING_MESSAGE_CUSTOM',
    GREETING_MESSAGE_DEFAULT: 'GREETING_MESSAGE_DEFAULT',
    GREETING_MESSAGE_AI: 'GREETING_MESSAGE_AI',
};
export const GetWidgetConfigResponseGreetingMessageTypeValue = {
    GREETING_MESSAGE_UNDEFINED: 0,
    GREETING_MESSAGE_NONE: 1,
    GREETING_MESSAGE_CUSTOM: 2,
    GREETING_MESSAGE_DEFAULT: 3,
    GREETING_MESSAGE_AI: 4,
};
export const GetMessageTemplateRequestHydrationOptionsHydrationEntityEntityType = {
    ENTITY_TYPE_UNDEFINED: 'ENTITY_TYPE_UNDEFINED',
    ENTITY_TYPE_PARTNER: 'ENTITY_TYPE_PARTNER',
    ENTITY_TYPE_ACCOUNT_GROUP: 'ENTITY_TYPE_ACCOUNT_GROUP',
    ENTITY_TYPE_CONTACT: 'ENTITY_TYPE_CONTACT',
};
export const GetMessageTemplateRequestHydrationOptionsHydrationEntityEntityTypeValue = {
    ENTITY_TYPE_UNDEFINED: 0,
    ENTITY_TYPE_PARTNER: 1,
    ENTITY_TYPE_ACCOUNT_GROUP: 2,
    ENTITY_TYPE_CONTACT: 3,
};
